export const SET_INVESTOR_APPLICATION_EMPLOYMENT_STATUS = 'SET_INVESTOR_APPLICATION_EMPLOYMENT_STATUS';

export const setInvestorEmploymentStatus = ({employment_status, employer = null, position_employed = null }) => ({
    type: SET_INVESTOR_APPLICATION_EMPLOYMENT_STATUS,
    payload: {
        employment_status,
        employer,
        position_employed,
    },
});